export enum NotificationTextLanguage {
  CA = 'ca',
  EL = 'el',
  EN = 'en',
  ES = 'es',
  EU = 'eu',
  FR = 'fr',
  HR = 'hr',
  HU = 'hu',
  IT = 'it',
  PT = 'pt',
  SL = 'sl',
}
